import React from 'react';

import NewGBDBecomesDefaultPopup from '../popups/NewGBDBecomesDefaultPopup';
import PollPopup from '../popups/PollPopup';

const AppNotifications = React.memo(() => (
    <>
        <NewGBDBecomesDefaultPopup />
        <PollPopup />
    </>
));

export default AppNotifications;
